import Vue from "vue";
import Vuex from "vuex";

import {
  getItem,
  setItem
} from "@/utils/storage";

Vue.use(Vuex);
const def = '8c8d7ef25e25fdf8e30cbb617b271a98'
export default new Vuex.Store({
  state: {
    m2oId: getItem("m2oId"),
    token: getItem("token"),
   
    deviceToken: getItem("deviceToken"),

    

  },
  mutations: {
    setNthUserId(state,data) {
      state.m2oId = data;
      setItem("m2oId", data);
    },

    setNthToken(state, data) {
      state.token = data;
      setItem("token", data);
    },
    setDeviceToken(state, data) {
      state.deviceToken = data;
      setItem("deviceToken", data);
    },


  },
  actions: {},
  modules: {},
});